export const basicFormData = () => ({
  inputData: {
    role_name: "",
    is_active: true,
    created_by: 1,
    updated_by: 1,
  },
});

export const createPageData = () => {
  const payload = {
    modelName: "state_masters",
    // whereCondition: {
    //   is_active: true,
    // },
  };

  const navigatePage = { back: "/state-list" };

  const headerName = "State";

  const validationType = "StateCreate";
  const createEndpoint = "/createState";
  const updateEndpoint = "/updateState";
  const getEndpoint = "/getStateById";

  return {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
  };
};

export const listPageData = () => {
  const payload = {
    modelName: "state_masters",
    relations: [
      {
        module: "user_masters",
        moduleAs: "createdBy",
      },
      {
        module: "user_masters",
        moduleAs: "updatedBy",
      },
    ],
  };

  const columnData = [
    { label: "sr.no", value: "index" },
    { label: "State Name", value: "state_name" },
    { label: "Created By", value: "createdBy.first_name" },
    { label: "Status", value: "is_active" },
    { label: "Action", value: "actions" },
  ];

  const navigatePage = {
    create: "/state-create",
    edit: "/state-create",
    view: "/state-view",
  };

  const searchfields = [
    "state_name",
    "createdBy.first_name",
    "createdBy.last_name",
    "updatedBy.first_name",
    "updatedBy.last_name",
  ];

  const headerName = "State";
  const endpoint = "/listState";

  const exportFileName = "stateData.xlsx";

  return {
    payload,
    navigatePage,
    headerName,
    columnData,
    endpoint,
    searchfields,
    exportFileName,
  };
};

export const exportPageData = {
  modelName: "state_masters",
  relations: [
    { module: "user_masters", moduleAs: "createdBy" },
    { module: "user_masters", moduleAs: "updatedBy" },
  ],
  pagination: { page: 1, pageSize: 10000 },
};
